import { ApolloClient } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import { AnalyticsEventType } from './graphql/api/graphql';
import getArticleSubjectType from './getArticleSubjectType';

const onLogin = async (
  data: { login: { accessToken: string } },
  setSubmitDisabled: (value: boolean) => void,
  successMessage: string,
  client: ApolloClient<object>,
  source: string,
  createAnalyticsEvent: (variables: Record<string, unknown>) => void,
  prefix: string,
  hasLocalNews: boolean,
  url: string,
  newsboard: string,
  id?: string | null,
) => {
  setSubmitDisabled(false);
  localStorage.setItem('accessToken', (data.login.accessToken));

  window.plausible('Login', {
    props: {
      provider: 'EmailAndPassword',
      source,
    },
  });

  createAnalyticsEvent({
    variables: {
      title: 'login',
      type: AnalyticsEventType.EVENT,
      url,
      payload: JSON.stringify({ newsboard }),
      subjectType: id ? getArticleSubjectType(prefix, hasLocalNews) : null,
      subjectId: id ? `${id}` : null,
    },
  });

  enqueueSnackbar(successMessage, { autoHideDuration: 1500 });

  await client.resetStore();
};

export default onLogin;
